<template>
    <div class="table">
        <div class="height-percent-100">
            <el-table
                stripe
                ref="stable"
                tooltip-effect="dark"
                style="width: 100%"
                :row-style="{ height: '38px' }"
                :header-cell-style="headCellStyle"
                :data="tableData"
                @selection-change="handleSelectionChange"
                height="100%"
                v-loading="loading"
                v-bind="$attrs"
            >
                <el-table-column type="selection" width="50" v-if="selection" />

                <el-table-column v-for="(item, index) in filteredColumns || columns" :key="index" :prop="item.index" :label="$t(item.title)" :show-overflow-tooltip="item.tooltip" :width="item.width">
                    <!-- 增加自定义表头 -->
                    <template v-if="item.headerComponent" slot="header">
                        <component :is="item.headerComponent" :index="item.index"></component>
                    </template>
                    <template #default="{row}">
                        <!-- 组件列渲染 -->
                        <template v-if="item.component">
                            <component :is="item.component" :row="row" :index="item.index"></component>
                        </template>
                        <!-- 普通的列渲染 -->
                        <template v-else>
                            <!-- 时间类型 -->
                            <template v-if="item.dataType === 'time'">
                                {{ $timetransition(row[item.index]) }}
                            </template>
                            <template v-else>
                                {{ row[item.index] }}
                            </template>
                        </template>
                    </template>
                </el-table-column>

                <!-- 先判断是否传入插槽  传入插槽给插槽外围包一列 -->
                <template v-if="$scopedSlots.operation">
                    <el-table-column :label="$t('integration.operation')" show-overflow-tooltip>
                        <template #default="{row}">
                            <div class="uk-flex uk-flex-center uk-flex-middle">
                                <slot name="operation" :row="row"></slot>
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>

        <!-- <Pagination
            class="pagination"
            ref="pagination"
            :total="total"
            :page.sync="params[0].iDisplayStart"
            v-if="getList"
            @pagination="getList"
            :page-size.sync="params[0].iDisplayLength"
            :limit.sync="params[0].iDisplayLength"
            :iDisplayLength="params[0].iDisplayLength"
            :pageSizes="[4, 10, 20, 30]"
        ></Pagination> -->

        <el-pagination
            background
            :current-page.sync="page"
            :page-size.sync="params[0].iDisplayLength"
            :layout="'total, sizes, prev, pager, next, jumper'"
            :page-sizes="pageSizes"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            v-bind="$attrs"
        ></el-pagination>
    </div>
</template>

<script>
// 引入默认暴露 也就是全部转换工具类  随后根据传入的图标类型传入工具类
import { _debounce } from '@/utils/common';

export default {
    props: {
        columns: {
            type: Array,
            default: () => []
        },
        req: {
            type: Function,
            default: () => Promise.resolve()
        },
        params: {
            type: Array,
            default: () => []
        },
        process: {},
        selection: {
            type: Boolean,
            default: false
        },
        // 数据路径
        dataPath: {},
        // 分页路径
        paginationPath: {},
        pageSizes: {
            default: () => [15, 20, 50, 100]
        }
    },
    watch: {
        params() {
            return {};
        }
    },
    data() {
        return {
            tableData: null,
            total: 0,
            getList: null,
            loading: false,
            filteredColumns: undefined,
            page: 1
        };
    },
    computed: {
        /** 用于表示当前登录用户属于什么类型的角色 */
        sysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            if (currentUser.sysScope && currentUser.sysAdmin) {
                // 系统管理员
                return 'isSysAdmin';
            } else if (currentUser.sysScope && !currentUser.sysAdmin) {
                // 系统非管理员
                return 'isSysNoAdmin';
            } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
                // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
                return 'noSysIsAdmin';
            } else {
                // 非系统非管理员
                return 'noSysNoAdmin';
            }
        }
    },
    methods: {
        reqList() {
            this.loading = true;
            this.req(...this.params)
                .then(res => {
                    const result = res.result;
                    this.filtrateColumns(this.columns);
                    if (this.dataPath) {
                        this.tableData = this.readPath(res, this.dataPath);
                    } else this.tableData = result;
                    if (this.paginationPath) {
                        this.total = this.readPath(res, this.paginationPath).total;
                    } else this.total = (result.pageInfo && result.pageInfo.total) || (res.pageInfo && res.pageInfo.total);
                })
                .finally(() => {
                    this.$nextTick(() => {
                        this.loading = false;
                    });
                });
        },
        handleSelectionChange(row) {
            this.$emit('selectData', row);
        },
        // 过滤列数据
        filtrateColumns(columns) {
            if (columns) {
                // 过滤权限数组
                this.filteredColumns = columns.filter(item => {
                    return item.hidden ? !item.hidden(this.$store.getters.userInfo.scope) : true;
                });
                return this.filteredColumns;
            }
            return columns;
        },
        getSelection() {
            return this.$refs.stable.selection;
        },
        readPath(data, path) {
            const split = path.split('.');
            let target = data;
            split.forEach(key => {
                target = target[key];
            });
            return target;
        },
        setPage(page) {
            this.page = page;
        },
        handleCurrentChange(page) {
            this.page = page;
            this.params[0].iDisplayStart = (this.page - 1) * this.params[0].iDisplayLength;
            this.getList();
        },
        handleSizeChange(size) {
            this.params[0].iDisplayLength = size;
            this.getList();
        }
    },

    mounted() {
        // 注意 ：getList暂时从外部调用 因为与v-search太耦合了
        this.getList = _debounce(this.reqList, 100);
    }
};
</script>

<style scoped lang="scss">
.table {
  height: calc(100% - 60px);
}

.operation {
  margin: 0 10px;
}

.pagination {
  padding-top: 0;
  padding-right: 15px !important;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

i.icon-hover {
  color: #CCCCCC;

  &:hover {
    color: #344962;
    font-weight: bold;
  }
}
::v-deep .el-pagination.is-background {
  display: flex;
  justify-content: flex-end;
  margin-top: 3px;
}

::v-deep .el-icon-arrow-left {
  color: #606266 !important;
}

</style>
